module.exports = __webpack_public_path__ + "static/media/icon.heart.alone.pink.5907ee9a.svg";